import { createNode } from '@glueapp/graph-types';

export const Or = createNode({
    id: 'Or',
    name: 'Or',
    description: 'Puts out true if one or both of the input values are true',
    aiDescription:
        'Logical OR of two booleans. Connect values to "Input1" and "Input2" ports; the "Output" port returns true if at least one input is true.',
    category: 'Logic',
    color: '#cd6205',
    integration: undefined,
    inPorts: {
        Input1: {
            kind: 'boolean',
        },
        Input2: {
            kind: 'boolean',
        },
    },
    outPorts: {
        Output: {
            kind: 'boolean',
        },
    },
    execute: function (input) {
        const inputValue1 = input.inPorts.Input1;
        const inputValue2 = input.inPorts.Input2;

        return { output: { Output: inputValue1 || inputValue2 } };
    },
});
